// src/proofSpecs/index.js
//
// Per-product live proof specifications.
// Key:   string product ID (matches product.id from the API)
// Value: spec object — see ProofBuilder for the shape
//
// To add a new product:
//   1. Open the product image in DevTools or an image editor
//   2. Measure each placeholder text region as % of image dimensions
//   3. Add an entry below with those percentages
//   4. Optionally supply a clean baseImage URL (no baked-in placeholder text)
//
// Example entry:
// '12': {
//   baseImage: null,           // null → use product.image; or supply a URL to a cleaner base
//   aspectRatio: '3 / 1',     // CSS aspect-ratio for the proof container
//   layers: [
//     {
//       field: 'name',         // dealership field: name | salesPhone | email | address | city | website
//       top: '70%',            // % of container height
//       left: '50%',           // % of container width
//       fontSize: 0.045,       // fraction of container width (e.g. 0.045 = 4.5%)
//       fontWeight: '700',
//       color: '#000000',
//       textAlign: 'center',
//       transform: 'translateX(-50%)',
//       coverBg: '#c8a96e',    // paint this color behind text to cover the placeholder
//       paddingX: 6,           // px of horizontal padding on the coverBg rect
//       paddingY: 2,           // px of vertical padding on the coverBg rect
//     },
//   ],
// },

export const PROOF_SPECS = {
// '13': {
//   "baseImage": null,
//   "aspectRatio": "2 / 1",
//   "layers": [
//     {
//       "field": "name",
//       "top": "50%",
//       "left": "50%",
//       "fontSize": 0.04,
//       "fontFamily": "CadillacGothic-NarrowMedium",
//       "color": "#000000",
//       "textAlign": "center",
//       "transform": "translateX(-50%)",
//       "coverBg": "#ffffff",
//       "coverArea": {
//         "left": "21.4%",
//         "top": "46.4%",
//         "width": "56.9%",
//         "height": "20.9%"
//       }
//     }
//   ]
// },

};
